import { createPortal } from "react-dom";
import { Upload } from "lucide-react";

/** Full-screen "drop it here" layer while files are dragged over a page that accepts them.
 *  Rendered into <body> so animated (transformed) parents can't trap the fixed layer. */
export const FileDropOverlay = ({ show, title = "Drop to upload", text, testid = "file-drop-overlay" }) =>
  show
    ? createPortal(
      <div className="pointer-events-none fixed inset-0 z-50 bg-panel/85 p-4 backdrop-blur-sm" data-testid={testid}>
        <div className="flex h-full flex-col items-center justify-center gap-3 rounded-3xl border-2 border-dashed border-brand text-center">
          <span className="grid size-14 place-items-center rounded-full bg-brand text-brand-foreground"><Upload className="size-6" /></span>
          <p className="text-lg font-semibold">{title}</p>
          {text && <p className="max-w-xs text-sm text-muted-foreground">{text}</p>}
        </div>
      </div>,
      document.body,
    )
    : null;
